import React from "react";
import PostSideBar from "./BlogsSideBar";

export default function SideBar() {
  return (
    <div className="col-lg-4 col-md-12 sidebar-right theiaStickySidebar">
      <div className="theiaStickySidebar">
        <PostSideBar />
      </div>
    </div>
  );
}
